<script setup lang="ts">
import { computed } from "vue";
import {
  convertSecondsFromStringTime,
  formatTimeFromSeconds,
} from "@/services/functions";

import DeliveryPlanType from "@/types/DeliveryPlan"
import AlertSettingType from "@/types/AlertSetting"

const props = defineProps<{
  detailDataRef: DeliveryPlanType[];
  index: number;
  detailData: DeliveryPlanType;
  alertSetting: AlertSettingType;
}>();

// 明細、小計の時間はアラートLv3をチェックしない
const restraintTimeStyle = computed(() => {
  const totalByTrip = summary("total_by_trip");
  if (!totalByTrip) return "color: black;";

  const restraintTimeSeconds = totalByTrip;

  const alertLv2TimeSeconds = convertSecondsFromStringTime(
    props.alertSetting?.alertLv2Time
  );
  if (
    props.alertSetting?.alertLv2Time &&
    restraintTimeSeconds > alertLv2TimeSeconds
  ) {
    return "color: " + props.alertSetting?.alertLv2Color;
  }

  const alertLv1TimeSeconds = convertSecondsFromStringTime(
    props.alertSetting?.alertLv1Time
  );
  if (
    props.alertSetting?.alertLv1Time &&
    restraintTimeSeconds > alertLv1TimeSeconds
  ) {
    return "color: " + props.alertSetting?.alertLv1Color;
  }

  return "color: black;";
});

const summaryTargetTrips = computed(() => {
  const trips = [];
  if (!props.detailData.weeklyAggregation) return trips;

  const cp = JSON.parse(JSON.stringify(props.detailDataRef));
  for (
    let i = props.index;
    i >= 0 && (i == props.index || !props.detailDataRef[i]?.weeklyAggregation);
    i--
  ) {
    if (!props.detailDataRef[i]) continue;
    (props.detailDataRef[i].trips ?? []).forEach((trip) => {
      trips.push(trip);
    });
  }
  return trips;
});

const summary = (key) => {
  let sum = 0;
  summaryTargetTrips.value.forEach((trip) => {
    sum += trip[key];
  });
  return sum;
};

// show formatted time

const formattedNextTimeByTrip = computed(() => {
  const sum = summary("next_time_by_trip");
  return formatTimeFromSeconds(sum);
});

const formattedTotalDriving = computed(() => {
  const sum = summary("total_driving");
  return formatTimeFromSeconds(sum);
});

const formattedTotalMileage = computed(() => {
  return summary("total_mileage");
});

const formattedDriving = computed(() => {
  const sum = summary("driving");
  return formatTimeFromSeconds(sum);
});

const formattedBreak = computed(() => {
  const sum = summary("break");
  return formatTimeFromSeconds(sum);
});

const formattedLoadingTime = computed(() => {
  const sum = summary("loading_time");
  return formatTimeFromSeconds(sum);
});

const formattedUnloadingTime = computed(() => {
  const sum = summary("unloading_time");
  return formatTimeFromSeconds(sum);
});

const formattedShippingTime = computed(() => {
  const sum = summary("shipping_time");
  return formatTimeFromSeconds(sum);
});

const formattedWaitTime = computed(() => {
  const sum = summary("wait_time");
  return formatTimeFromSeconds(sum);
});

const formattedOthersTime = computed(() => {
  const sum = summary("others_time");
  return formatTimeFromSeconds(sum);
});

const formattedTotalByTrip = computed(() => {
  const sum = summary("total_by_trip");
  return formatTimeFromSeconds(sum);
});

const formattedWorkingTime = computed(() => {
  const sum = summary("working_time");
  return formatTimeFromSeconds(sum);
});

const formattedLeavingDiffTime = computed(() => {
  const sum = summary("leaving_diff_time");
  return formatTimeFromSeconds(sum);
});

const formattedOverTime = computed(() => {
  const sum = summary("over_time");
  return formatTimeFromSeconds(sum);
});

const formattedOverNightTime = computed(() => {
  const sum = summary("over_night_time");
  return formatTimeFromSeconds(sum);
});
</script>

<template>
  <tr v-show="!!detailData.weeklyAggregation">
    <td colspan="4">小計</td>
    <td>{{ formattedTotalDriving }}</td>
    <td>{{ formattedNextTimeByTrip }}</td>
    <td>{{ formattedTotalMileage }}</td>
    <td>{{ formattedDriving }}</td>
    <td>{{ formattedBreak }}</td>
    <td>{{ formattedLoadingTime }}</td>
    <td>{{ formattedUnloadingTime }}</td>
    <td>{{ formattedShippingTime }}</td>
    <td>{{ formattedWaitTime }}</td>
    <td>{{ formattedOthersTime }}</td>
    <td :style="restraintTimeStyle">
      {{ formattedTotalByTrip }}
    </td>
    <td>{{ formattedWorkingTime }}</td>
    <td>{{ formattedLeavingDiffTime }}</td>
    <td></td>
    <td></td>
    <td></td>
    <td>{{ formattedOverTime }}</td>
    <td>{{ formattedOverNightTime }}</td>
  </tr>
</template>

<style scoped>
#trip-detail-table td {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
#trip-detail-table .table-header {
  background-color: silver !important;
}
#trip-detail-table tr {
  line-height: 15px;
  font-size: 13px;
  font-weight: bold;
}
</style>
